import { useState } from 'react';

interface Product {
  id: number;
  name: string;
  genericName: string;
  image: string;
  category: string;
  isNew?: boolean;
  description: string;
}

interface ProductsGridProps {
  activeCategory: string;
}

export default function ProductsGrid({ activeCategory }: ProductsGridProps) {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

 const allProducts: Product[] = [
  // Cardiovascular
  {
    id: 1,
    name: 'NITRODIL',
    genericName: 'Nitroglycerin 2.6 Tab',
    image: 'assets/Products/Product_1.jpg',
    category: 'cardiovascular',
    isNew: true,
    description: 'A potent Vasodilator.\nUsed in Angina pectoris.\nHeart Attack.\nHypertensive Crises.'
  },
  {
    id: 2,
    name: 'NITRODIL',
    genericName: 'Nitroglycerin 6.4 Tab',
    image: 'assets/Products/Product_2.jpg',
    category: 'cardiovascular',
    description: 'A potent Vasodilator.\nUsed in Angina pectoris.\nHeart Attack.\nHypertensive Crises.'
  },
  {
    id: 3,
    name: 'NESDIL',
    genericName: 'Nicorandil 5mg Tab',
    image: 'assets/Products/Product_3.jpg',
    category: 'cardiovascular',
    description: 'Shows Anti-Ischemic & Cardioprotective Benefits for a wide Range of Coronary Artery Disease.\nPatients with different risk factors.'
  },
  {
    id: 4,
    name: 'NESDIL',
    genericName: 'Nicorandil 10mg Tab',
    image: 'assets/Products/Product_4.jpg',
    category: 'cardiovascular',
    description: 'Shows Anti-Ischemic & Cardioprotective Benefits for a wide Range of Coronary Artery Disease.\nPatients with different risk factors.'
  },
  {
    id: 5,
    name: 'MESTA XL',
    genericName: 'Metoprolol 50mg Tab',
    image: 'assets/Products/Product_5.jpg',
    category: 'cardiovascular',
    description: 'Used in Hypertension.\nAngina pectoris.\nSupravantricular Tacchycardia.'
  },
  {
    id: 6,
    name: 'MESTA XL',
    genericName: 'Metoprolol 25mg Tab',
    image: 'assets/Products/Product_6.jpg',
    category: 'cardiovascular',
    description: 'Used in Hypertension.\nAngina pectoris.\nSupravantricular Tacchycardia.'
  },
  {
    id: 7,
    name: 'MESTA R',
    genericName: 'Ramipril 2.5mg Tab',
    image: 'assets/Products/Product_7.jpg',
    category: 'cardiovascular',
    description: 'Used in Chest Pain.\nHeart Failure.\nHigh Blood Pressure.'
  },
  {
    id: 8,
    name: 'MESTA R',
    genericName: 'Ramipril 5mg Tab',
    image: 'assets/Products/Product_8.jpg',
    category: 'cardiovascular',
    description: 'Used in Chest Pain.\nHeart Failure.\nHigh Blood Pressure.'
  },
  {
    id: 9,
    name: 'TELMISUN',
    genericName: 'Telmisartan 40mg Tab',
    image: 'assets/Products/Product_9.jpg',
    category: 'cardiovascular',
    description: 'Used in Early Hypertension.\nEdema in Hypertensives.'
  },
  {
    id: 10,
    name: 'TELMISUN',
    genericName: 'Telmisartan 80mg Tab',
    image: 'assets/Products/Product_13.jpg',
    category: 'cardiovascular',
    description: 'Used in Early Hypertension.\nEdema in Hypertensives.'
  },

  // Diabetic
  {
    id: 11,
    name: 'TELMISUN-AM',
    genericName: 'Telmisartan 40mg + Amlodipine 5mg Tab',
    image: 'assets/Products/Product_11.jpg',
    category: 'diabetic',
    isNew: true,
    description: 'An Antihypertensive combination.\nControls BP.\nReduces Cardiovascular Events.'
  },
  {
    id: 12,
    name: 'TELMISUN-CH',
    genericName: 'Telmisartan 40mg + Chlorthalidone 12.5mg Tab',
    image: 'assets/Products/Product_12.jpg',
    category: 'diabetic',
    description: 'Where Hypertension is not controlled with Monotherapy.'
  },
  {
    id: 14,
    name: 'ROZUNEW GOLD',
    genericName: 'Rosuvastatin 10mg + Chlopidogrel 75mg + Aspirin 75mg',
    image: 'assets/Products/Product_14.jpg',
    category: 'diabetic',
    description: 'Primary Hypercholesterolemia.\nDyslipidemia.\nCoronary Heart Disease.'
  },
  {
    id: 15,
    name: 'SACCUDIL 50',
    genericName: 'Saccubitril 24/51 + Valsartin 26/49',
    image: 'assets/Products/Product_15.jpg',
    category: 'diabetic',
    description: 'For the treatment of Heart Failure.\nReduces Risk of Hospitalization.\nImproves survival rate.'
  },
  {
    id: 16,
    name: 'SACCUDIL 100',
    genericName: 'Saccubitril 24/51 + Valsartin 26/49',
    image: 'assets/Products/Product_16.jpg',
    category: 'diabetic',
    description: 'For the treatment of Heart Failure.\nReduces Risk of Hospitalization.\nImproves survival rate.'
  },
  {
    id: 17,
    name: 'DAPAFILL-10',
    genericName: 'Dapagliflozin 10mg',
    image: 'assets/Products/Product_17.jpg',
    category: 'diabetic',
    description: 'Patients with Diabetes are at high risk for adverse outcomes from Atherosclerosis.\nCardiovascular Disease.\nHeart Failure.\nRenal Disease.'
  },
  {
    id: 18,
    name: 'DAPAFILL-M',
    genericName: 'Dapagliflozin 10mg + Metformin 500mg Tab',
    image: 'assets/Products/Product_18.jpg',
    category: 'diabetic',
    description: 'Second-generation sulfonylurea.\nPancreatic beta cell stimulation.'
  },

  // Quality Medicines
  {
    id: 19,
    name: 'ESGLIM-M1',
    genericName: 'Glimipiride 1mg + Metformin 500mg SR Tab',
    image: 'assets/Products/Product_19.jpg',
    category: 'quality',
    isNew: true,
    description: 'An OAD that provides Good Glycemic Control.\nIncludes A1C.\nPPG.\nFasting.'
  },
  {
    id: 20,
    name: 'ESGLIM-M2',
    genericName: 'Glimipiride 2mg + Metformin 500mg SR Tab',
    image: 'assets/Products/Product_20.jpg',
    category: 'quality',
    description: 'Macrolide antibiotic.\nExtended tissue penetration.\nBroad antimicrobial coverage.'
  },
  {
    id: 21,
    name: 'ESGLIM-MV1',
    genericName: 'Voglibose 0.2mg + Glimipiride 1mg + Metformin 500mg SR Tab',
    image: 'assets/Products/Product_21.jpg',
    category: 'quality',
    description: 'Used in Management of Post Prandial Hyperglycemia.'
  },
  {
    id: 22,
    name: 'ESGLIM-MV2',
    genericName: 'Voglibose 0.2mg + Glimipiride 2mg + Metformin 500mg SR Tab',
    image: 'assets/Products/Product_22.jpg',
    category: 'quality',
    description: 'Used in Management of Post Prandial Hyperglycemia.'
  }
];


  const filteredProducts = activeCategory === 'all' 
    ? allProducts 
    : allProducts.filter(p => p.category === activeCategory);

  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'cardiovascular':
        return 'bg-blue-50 text-blue-700 border-blue-200';
      case 'diabetic':
        return 'bg-teal-50 text-teal-700 border-teal-200';
      case 'quality':
        return 'bg-purple-50 text-purple-700 border-purple-200';
      default:
        return 'bg-gray-50 text-gray-700 border-gray-200';
    }
  };

  const getCategoryName = (category: string) => {
    switch (category) {
      case 'cardiovascular':
        return 'Cardiovascular';
      case 'diabetic':
        return 'Diabetic Care';
      case 'quality':
        return 'Quality Medicine';
      default:
        return category;
    }
  };

  const getCategoryBorderColor = (category: string) => {
    switch (category) {
      case 'cardiovascular':
        return 'hover:border-blue-400';
      case 'diabetic':
        return 'hover:border-teal-400';
      case 'quality':
        return 'hover:border-purple-400';
      default:
        return 'hover:border-gray-400';
    }
  };

  return (
    <>
      {/* All Medicines Section */}
      {activeCategory === 'all' && (
        <section id="all" className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                All Medicines
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Browse our complete pharmaceutical portfolio featuring cardiovascular, diabetic care, and quality medicines.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-product-shop>
              {filteredProducts.map((product) => (
                <div
                  key={product.id}
                  className={`group bg-white rounded-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-200 ${getCategoryBorderColor(product.category)} cursor-pointer relative`}
                  onClick={() => setSelectedProduct(product)}
                >
                  {product.isNew && (
                    <div className="absolute top-3 right-3 bg-orange-500 text-white text-xs font-bold px-3 py-1.5 rounded-full z-10 shadow-lg">
                      NEW
                    </div>
                  )}
                  <div className="h-40 p-4 flex items-center justify-center bg-gradient-to-br from-gray-50 to-white">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="p-5 border-t border-gray-100">
                    <h3 className="text-base font-bold text-gray-900 mb-1.5">{product.name}</h3>
                    <p className="text-sm text-gray-600 mb-3 font-medium">{product.genericName}</p>
                    {/* <span className={`inline-block text-xs font-semibold px-3 py-1.5 rounded-lg border ${getCategoryColor(product.category)}`}>
                      {getCategoryName(product.category)}
                    </span> */}
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity mt-4">
                      <span className="text-gray-900 text-sm font-semibold flex items-center">
                        View Details
                        <i className="ri-arrow-right-line ml-1"></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Cardiovascular Section */}
      {(activeCategory === 'cardiovascular' || activeCategory === 'all') && activeCategory !== 'all' && (
        <section id="cardiovascular" className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Cardiovascular Medicines 💙
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Specialized cardiac medications for comprehensive cardiovascular care and heart health management.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-product-shop>
              {allProducts.filter(p => p.category === 'cardiovascular').map((product) => (
                <div
                  key={product.id}
                  className="group bg-white rounded-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-200 hover:border-blue-400 cursor-pointer relative"
                  onClick={() => setSelectedProduct(product)}
                >
                  {product.isNew && (
                    <div className="absolute top-3 right-3 bg-orange-500 text-white text-xs font-bold px-3 py-1.5 rounded-full z-10 shadow-lg">
                      NEW
                    </div>
                  )}
                  <div className="h-40 p-4 flex items-center justify-center bg-gradient-to-br from-blue-50 to-white">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="p-5 border-t border-gray-100">
                    <h3 className="text-base font-bold text-gray-900 mb-1.5">{product.name}</h3>
                    <p className="text-sm text-gray-600 mb-3 font-medium">{product.genericName}</p>
                    {/* <span className="inline-block bg-blue-50 text-blue-700 text-xs font-semibold px-3 py-1.5 rounded-lg border border-blue-200">
                      Cardiovascular
                    </span> */}
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity mt-4">
                      <span className="text-blue-600 text-sm font-semibold flex items-center">
                        View Details
                        <i className="ri-arrow-right-line ml-1"></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Diabetic Section */}
      {(activeCategory === 'diabetic' || activeCategory === 'all') && activeCategory !== 'all' && (
        <section id="diabetic" className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Diabetic Care Medicines 💉
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Advanced diabetic medications for effective blood sugar management and diabetes control.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-product-shop>
              {allProducts.filter(p => p.category === 'diabetic').map((product) => (
                <div
                  key={product.id}
                  className="group bg-white rounded-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-200 hover:border-teal-400 cursor-pointer relative"
                  onClick={() => setSelectedProduct(product)}
                >
                  {product.isNew && (
                    <div className="absolute top-3 right-3 bg-orange-500 text-white text-xs font-bold px-3 py-1.5 rounded-full z-10 shadow-lg">
                      NEW
                    </div>
                  )}
                  <div className="h-40 p-4 flex items-center justify-center bg-gradient-to-br from-teal-50 to-white">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="p-5 border-t border-gray-100">
                    <h3 className="text-base font-bold text-gray-900 mb-1.5">{product.name}</h3>
                    <p className="text-sm text-gray-600 mb-3 font-medium">{product.genericName}</p>
                    {/* <span className="inline-block bg-teal-50 text-teal-700 text-xs font-semibold px-3 py-1.5 rounded-lg border border-teal-200">
                      Diabetic Care
                    </span> */}
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity mt-4">
                      <span className="text-teal-600 text-sm font-semibold flex items-center">
                        View Details
                        <i className="ri-arrow-right-line ml-1"></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Quality Medicines Section */}
      {(activeCategory === 'quality' || activeCategory === 'all') && activeCategory !== 'all' && (
        <section id="quality" className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Quality Medicines 💊
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Premium pharmaceutical products for various health conditions with proven efficacy and safety.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-product-shop>
              {allProducts.filter(p => p.category === 'quality').map((product) => (
                <div
                  key={product.id}
                  className="group bg-white rounded-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-200 hover:border-purple-400 cursor-pointer relative"
                  onClick={() => setSelectedProduct(product)}
                >
                  {product.isNew && (
                    <div className="absolute top-3 right-3 bg-orange-500 text-white text-xs font-bold px-3 py-1.5 rounded-full z-10 shadow-lg">
                      NEW
                    </div>
                  )}
                  <div className="h-40 p-4 flex items-center justify-center bg-gradient-to-br from-purple-50 to-white">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="p-5 border-t border-gray-100">
                    <h3 className="text-base font-bold text-gray-900 mb-1.5">{product.name}</h3>
                    <p className="text-sm text-gray-600 mb-3 font-medium">{product.genericName}</p>
                    {/* <span className="inline-block bg-purple-50 text-purple-700 text-xs font-semibold px-3 py-1.5 rounded-lg border border-purple-200">
                      Quality Medicine
                    </span> */}
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity mt-4">
                      <span className="text-purple-600 text-sm font-semibold flex items-center">
                        View Details
                        <i className="ri-arrow-right-line ml-1"></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Product Modal */}
      {selectedProduct && (
        <div
          className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-6"
          onClick={() => setSelectedProduct(null)}
        >
          <div
            className="bg-white rounded-2xl max-w-3xl w-full p-10 relative shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedProduct(null)}
              className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            <div className="grid md:grid-cols-2 gap-10">
              <div className="flex items-center justify-center bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 border border-gray-200">
                <img
                  src={selectedProduct.image}
                  alt={selectedProduct.name}
                  className="w-full h-auto object-contain"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-3">{selectedProduct.name}</h3>
                <p className="text-xl text-gray-700 mb-5 font-medium">{selectedProduct.genericName}</p>
                <div className="mb-6">
                  {/* <span className={`inline-block text-sm font-semibold px-4 py-2 rounded-lg border ${getCategoryColor(selectedProduct.category)}`}>
                    {getCategoryName(selectedProduct.category)}
                  </span> */}
                </div>
                <p className="text-gray-600 text-base leading-relaxed mb-6">
                  {selectedProduct.description.split('\n').map((line, index) => (
                    <span key={index}>
                      {line}
                      <br />
                    </span>
                  ))}
                </p>
                <div className="bg-blue-50 p-5 rounded-xl border border-blue-200">
                  <p className="text-sm text-blue-900 font-semibold flex items-start">
                    <i className="ri-information-line mr-2 mt-0.5 text-lg"></i>
                    <span>Prescription medication - Available through authorized healthcare providers</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}